"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarWithName = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var Typography_1 = require("../Typography");
var AvatarWithName = function (_a) {
    var children = _a.children, avatarProps = _a.avatarProps, typographyProps = _a.typographyProps, loading = _a.loading, wrapperProps = _a.wrapperProps;
    return (react_1.default.createElement("div", { style: __assign({ display: "flex", columnGap: 8, alignItems: "center" }, wrapperProps) },
        react_1.default.createElement("div", { className: "user-avatar-div" }, loading ? (react_1.default.createElement(antd_1.Skeleton.Avatar, { size: "small" })) : (react_1.default.createElement(antd_1.Avatar, __assign({ icon: !((avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.src) ||
                (avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.icon) ||
                (avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.children)) && react_1.default.createElement(icons_1.UserOutlined, null) }, avatarProps)))),
        react_1.default.createElement("div", { style: { textAlign: "start", flexGrow: 1 } },
            react_1.default.createElement(Typography_1.Typography, __assign({ loadingSize: "full", loading: loading, ellipsis: true }, typographyProps), children))));
};
exports.AvatarWithName = AvatarWithName;
